import _ from 'lodash'
import { NReports } from '../Rpts/Rpts.types'
import type { Type_ILocationFocusList, Type_IReport } from '../Type/Type.hive'

export function Loca_prepareFocusList(focusList: Type_ILocationFocusList, reports: Type_IReport[]) {
    const startDate = new Date(focusList.range.startDate)
    const endDate = new Date(focusList.range.endDate)
    reports = reports.filter((report) => {
        const date = NReports.isSyncReport(report) ? new Date(report.date) : new Date(report.startDate)
        return date > startDate && date < endDate
    })

    const locations = focusList.locations.map((location: any) => {
        const relevantReports = reports.filter((report) => report.location === location.id)

        // Flag uploaded & not-uploaded reports for the display logic
        const uploadedReports = relevantReports
            .filter((report) => report.onlineId !== undefined)
            .map((report) => ({
                id: report.onlineId,
                uploaded: true,
            }))

        const localReports = relevantReports
            .filter((report) => report.uploaded === false)
            .map((report) => ({
                id: report.reportId,
                uploaded: false,
            }))

        const focusListReports = location.reports.map((entry: any) => ({ id: entry.id, uploaded: true }))

        // Combine all reports together. We remove duplicates between our uploaded reports that we
        // know about and the reports coming from the focus list as they might be the same.
        return {
            ...location,
            reports: _.concat(_.uniqBy(_.concat(uploadedReports, focusListReports), 'id'), localReports),
        }
    })

    return { ...focusList, locations }
}
